import Highcharts from "highcharts";

export function getContrastedColor(colorToContrast: string, darkColor = '#1F2123', lightColor = 'white'): string {
  // @ts-ignore
  const { rgba } = Highcharts.color(colorToContrast);
  if(rgba[3] !== 1) { // If the color is semi/transparent, default to dark color for simplicity
    return darkColor;
  }
  const luminance = (0.299 * rgba[0] + 0.587 * rgba[1] + 0.114 * rgba[2]) / 255; // Based on relative luminance formula, normalized to 0-1
  return luminance > 0.5 ? darkColor : lightColor;
}